import { Checkout, Prizes } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router'
import './checkouts.page.scoped.scss'
import ItemCheckoutedComponent from './components/item-checkouted.component'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  checkouts: Checkout[]
  prizes: Prizes[]
  pathname: string
}

export default ({ checkouts, prizes = [], pathname }: Props) => {
  const [t] = useTranslation('engage')

  if (!prizes?.length) {
    return <Navigate to={`${pathname?.replace('prizes', 'pointing')}`} />
  }

  return (
    <div className="engage-checkouts-page">
      <h5>{t('checkoutsPage.title')}</h5>
      <ul className="checkouts-list">
        {checkouts?.map((checkout) => (
          <li key={checkout._id}>
            <ItemCheckoutedComponent checkout={checkout} />
          </li>
        ))}
        {checkouts?.length === 0 && <li className="empty">{t('checkoutsPage.empty')}</li>}
      </ul>
    </div>
  )
}
